import React from 'react';
import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined, InfoCircleOutlined } from '@ant-design/icons';

interface ActivityItemProps {
  type: 'success' | 'error' | 'info' | 'deploying';
  title: string;
  description: string;
  time: string;
  project?: string;
}

const ActivityItem: React.FC<ActivityItemProps> = ({ 
  type, 
  title, 
  description, 
  time,
  project 
}) => {
  const typeConfig = {
    success: { 
      icon: <CheckCircleOutlined />, 
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    error: { 
      icon: <CloseCircleOutlined />, 
      color: 'text-red-600',
      bgColor: 'bg-red-50'
    },
    info: { 
      icon: <InfoCircleOutlined />, 
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    deploying: { 
      icon: <SyncOutlined spin />, 
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
  };

  const config = typeConfig[type];

  return (
    <div className="flex gap-4 py-4 border-b border-gray-100 dark:border-gray-700 last:border-0 hover:bg-gray-50 dark:hover:bg-gray-800 px-3 -mx-3 rounded transition-colors">
      <div className={`${config.bgColor} ${config.color} w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-base`}>
        {config.icon}
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <div>
            <p className="text-sm font-medium text-gray-900 dark:text-white">{title}</p>
            <p className="text-xs text-gray-500 mt-0.5">{description}</p>
            {project && (
              <span className="inline-block mt-1.5 text-xs text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 px-2 py-0.5 rounded">
                {project}
              </span>
            )}
          </div>
          <span className="text-xs text-gray-400 whitespace-nowrap">{time}</span>
        </div>
      </div>
    </div>
  );
};

export default ActivityItem;